import baseAPI from '@/api/base';
import {
  EditDateTimeBanner,
  GetDateTimeBanner,
  RegisterDateTimeBanner,
} from '@/dtos/date_time_banner.dto';
import {
  DELETE_DATE_TIME_BANNER_URL,
  EDIT_DATE_TIME_BANNER_URL,
  GET_DATE_TIME_BANNER_URL,
  REGISTER_DATE_TIME_BANNER_URL,
  TOGGLE_DATE_TIME_BANNER_IS_ACTIVE_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

class DateTimeBanner {
  static getDateTimeBanners = async (
    getDateTimeBanner: GetDateTimeBanner
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_DATE_TIME_BANNER_URL, {
      params: getDateTimeBanner,
    });
    console.log('response', response);
    return response;
  };

  static registerDateTimeBanner = async (
    registerDateTimeBanner: RegisterDateTimeBanner
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(
      REGISTER_DATE_TIME_BANNER_URL,
      {
        ...registerDateTimeBanner,
      }
    );
    console.log('response', response);
    return response;
  };

  static editDateTimeBanner = async (
    editDateTimeBanner: EditDateTimeBanner
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(
      EDIT_DATE_TIME_BANNER_URL,
      {
        ...editDateTimeBanner,
      }
    );
    return response;
  };

  static toggleDateTimeBannerIsActive = async (
    editDateTimeBanner: EditDateTimeBanner
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(
      TOGGLE_DATE_TIME_BANNER_IS_ACTIVE_URL,
      {
        ...editDateTimeBanner,
      }
    );
    return response;
  };

  static deleteDateTimeBanner = async (
    id: string
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_DATE_TIME_BANNER_URL}/${id}`
    );
    return response;
  };
}

export default DateTimeBanner;
